// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"82a000ba","288":"845ede62","393":"1fb05bbe","433":"05fbe80e","520":"57027621","558":"e8a36763","958":"7c774906","973":"48551908"}[chunkId] + ".chunk.js";
};